export default "__VITE_ASSET__7262a2fa__"